/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type CreateRequestWithEventMutationVariables = Types.Exact<{
    input: Types.CreateRequestWithEvent;
}>;

export type CreateRequestWithEventMutation = {
    __typename: 'Mutation';
    createRequestWithEvent: { __typename: 'Request'; publicId: string };
};

export type CreateRequestMutationVariables = Types.Exact<{
    input: Types.CreateRequestInput;
    usePreferredDesigner?: Types.Maybe<Types.Scalars['Boolean']>;
    experimentVariants?: Types.Maybe<Types.Scalars['Map']>;
}>;

export type CreateRequestMutation = {
    __typename: 'Mutation';
    createRequest: {
        __typename: 'Request';
        facts: Types.Maybe<{ __typename: 'RequestFacts'; currentUrl: Types.Maybe<string> }>;
    };
};

export const CreateRequestWithEventDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateRequestWithEvent' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CreateRequestWithEvent' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createRequestWithEvent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type CreateRequestWithEventMutationFn = Apollo.MutationFunction<
    CreateRequestWithEventMutation,
    CreateRequestWithEventMutationVariables
>;

/**
 * __useCreateRequestWithEventMutation__
 *
 * To run a mutation, you first call `useCreateRequestWithEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestWithEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestWithEventMutation, { data, loading, error }] = useCreateRequestWithEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequestWithEventMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateRequestWithEventMutation,
        CreateRequestWithEventMutationVariables
    >
) {
    return Apollo.useMutation<
        CreateRequestWithEventMutation,
        CreateRequestWithEventMutationVariables
    >(CreateRequestWithEventDocument, baseOptions);
}
export type CreateRequestWithEventMutationHookResult = ReturnType<
    typeof useCreateRequestWithEventMutation
>;
export type CreateRequestWithEventMutationResult =
    Apollo.MutationResult<CreateRequestWithEventMutation>;
export type CreateRequestWithEventMutationOptions = Apollo.BaseMutationOptions<
    CreateRequestWithEventMutation,
    CreateRequestWithEventMutationVariables
>;
export const CreateRequestDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateRequest' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CreateRequestInput' },
                        },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'usePreferredDesigner' },
                    },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'experimentVariants' },
                    },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Map' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createRequest' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'usePreferredDesigner' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'usePreferredDesigner' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'experimentVariants' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'experimentVariants' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'facts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currentUrl' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type CreateRequestMutationFn = Apollo.MutationFunction<
    CreateRequestMutation,
    CreateRequestMutationVariables
>;

/**
 * __useCreateRequestMutation__
 *
 * To run a mutation, you first call `useCreateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestMutation, { data, loading, error }] = useCreateRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *      usePreferredDesigner: // value for 'usePreferredDesigner'
 *      experimentVariants: // value for 'experimentVariants'
 *   },
 * });
 */
export function useCreateRequestMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateRequestMutation, CreateRequestMutationVariables>
) {
    return Apollo.useMutation<CreateRequestMutation, CreateRequestMutationVariables>(
        CreateRequestDocument,
        baseOptions
    );
}
export type CreateRequestMutationHookResult = ReturnType<typeof useCreateRequestMutation>;
export type CreateRequestMutationResult = Apollo.MutationResult<CreateRequestMutation>;
export type CreateRequestMutationOptions = Apollo.BaseMutationOptions<
    CreateRequestMutation,
    CreateRequestMutationVariables
>;
